module.exports = {"610726001":"汉源街道","610726002":"高寨子街道","610726102":"大安镇","610726103":"代家坝镇","610726104":"阳平关镇","610726105":"燕子砭镇","610726106":"广坪镇","610726107":"青木川镇","610726108":"毛坝河镇","610726109":"铁锁关镇","610726110":"胡家坝镇","610726111":"巴山镇","610726112":"巨亭镇","610726113":"舒家坝镇","610726117":"太阳岭镇","610726118":"安乐河镇","610726119":"二郎坝镇","610726120":"禅家岩镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610726.json
// module id = 2992
// module chunks = 0